import { EMBED_LIB_URL, WEBAPP_URL } from "@phnxtech/lib/constants";

export const embedLibUrl = EMBED_LIB_URL;
export const EMBED_PREVIEW_HTML_URL = `${WEBAPP_URL}/embed/preview.html`;
export const enum EmbedTheme {
  auto = "auto",
  light = "light",
  dark = "dark",
}
